module.exports = "<app-widgets-collapsable-panel class=relation-category-panel hide-tools=true ng-repeat=\"type in $ctrl.protectionAreaTypes\"> <panel-title> <span>{{ $ctrl.appAreaLabelTranslator.getPluralLabel(type) }}</span> <span ng-if=\"$ctrl.route.protection_areas[type].length > 0\">({{ $ctrl.route.protection_areas[type].length }})</span> </panel-title> <panel-body> <app-area-relation type=type area-list=$ctrl.route.protection_areas[type] read-only=true> </app-area-relation> </panel-body> </app-widgets-collapsable-panel>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/areas/partial.html
// module id = 497
// module chunks = 0